// override of `packages/legacy/src/organization-context.ts` for migration purpose

import { createContext } from 'react';

import type { Organization, OrganizationDetail } from '@rtkwlf/eloc';
import { useQuery } from '@tanstack/react-query';

import { organizationQuery } from '@apis/eloc/queries/organization';
import { useOrganizationParam } from '@packages/hooks/use-organization-param';

type OrganizationContextType = {
  /**
   * Current selected Organization
   */
  selectedOrganization: OrganizationDetail;

  /**
   * Select Organization
   */
  selectOrganization: (org: Organization, callBack?: () => void) => void;
};

export const OrganizationContext =
  createContext<OrganizationContextType | null>(null);

export const useOrganizationContext = () => {
  const organizationId = useOrganizationParam();

  const { data } = useQuery(organizationQuery(organizationId));

  return {
    selectedOrganization: data,
    selectOrganization: () => {
      throw new Error('selectOrganization must not be called in UP.IA');
    },
  };
};

export const useSelectedOrganization = () => {
  const context = useOrganizationContext();
  return context.selectedOrganization;
};
